import { DuplicatingService } from '../../../_services/duplicating.service';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { FactService } from 'src/app/_services/fact.service';

@Component({
  selector: 'app-fact-show',
  templateUrl: './fact-show.component.html',
  styleUrls: ['./fact-show.component.css']
})
export class FactShowComponent implements OnInit {
  server_fact_id=0
  hoaxBookList =[]
  currentHoaxList =undefined
  fact:any=undefined
  subTopics:any=undefined
  loading=false
  constructor(private factService:FactService, private activatedRoute: ActivatedRoute, private router:Router,private duplicatingService:DuplicatingService) { }

  ngOnInit(): void {
    this.loading=true
    this.activatedRoute.params.subscribe(
      myP=>{
        this.server_fact_id=myP['server_fact_id']
        this.factService.getFactBookItem(this.server_fact_id).subscribe({
          next:(data:ResultData)=>{
            this.fact=data.rs.data
            this.loading=false
            this.loadSubTopics()
            this.factService.getHoaxList(this.server_fact_id).subscribe({
              next:(data:ResultData)=>{
                this.currentHoaxList=data.rs.data
              },
              error:(err)=>{
                console.error("error reading sample task",err)
              }
            })
          }
        }

        )
      }
    )
    }
  duplicateFactBook(){
    this.duplicatingService.dupFactBook.next(this.fact)
    this.router.navigate(['/admin/fact/new',1])
  }

  loadSubTopics(){
    this.factService.getSubTopicByFact(this.fact.server_fact_id).subscribe({
      next: (data: ResultData) => {
        this.subTopics = data.rs.data;
      },
      error: (err) => {
        console.error('Error loading subtopics', err);
      }
    }

    )

  }
testFact(){
  this.factService.testFact(this.fact.server_fact_id).subscribe({
    next: (data: ResultData) => {
      this.fact = data.rs.data;
    },
    error: (err) => {
      console.error('Error loading subtopics', err);
    }
  }

  )
}
  removeHoax(hoaxId:number){
    this.factService.removeHoax(this.fact.id,hoaxId).subscribe({
      next: () => {
        this.currentHoaxList = this.currentHoaxList.filter((hoax: any) => hoax.id !== hoaxId);
      },
      error: (err) => {
        console.error(`Error removing hoax with ID ${hoaxId}`, err);
      }
    });
  }



}
